import { Box, Flex } from '@chakra-ui/react';

import { DownloadIcon } from 'Asset/icon';
import useGetBrand from 'Domain/brand/useGetBrand';
import useGetExportReportHostTask from 'Domain/report-host-tasks/useGetExportReportHostTask';
import { ReportHostTasksText } from 'Const/report-host-tasks/view';
import ButtonSolid from 'UiKit/button/buttonSolid';
import SearchComponent from 'UiKit/search';
import FilterSelect from 'UiKit/filter-select';
import { TextRegular, TextSemiBold } from 'UiKit/typography';
import FilterDatepicker from 'UiKit/filter-datepicker';

import { useReportHostTasksState } from 'View/report-host-tasks/state';

import styles from './styles.module.css';

const Filter = ({ t }) => {
  const { filterState, updateFilterState } = useReportHostTasksState();
  const { mutate: exportReportHostTask } = useGetExportReportHostTask();

  const { data: brandOptions, isLoading: isLoadingBrand } = useGetBrand({ enabled: true });

  const handleExport = () => {
    exportReportHostTask(filterState);
  };

  const handleFilter = ({ field, value }) => {
    updateFilterState({
      page: 1,
      [field]: value,
    });
  };

  return (
    <Box className={styles['filter__container']}>
      <Box className={styles['filter__field--container']}>
        <SearchComponent width="377px" value={filterState?.search} debounceTime={300} u onSearch={(value) => handleFilter({ value, field: 'search' })} />

        <FilterSelect
          value={filterState?.brand}
          onChange={(value) => handleFilter({ field: 'brand', value })}
          placeholder={t('filter.selectBrand')}
          clearable={true}
          options={brandOptions}
          isLoading={isLoadingBrand}
          width="168px"
        />

        <Flex className={`${styles['filter__item']} ${styles['filter__item--date-range']}`}>
          <FilterDatepicker
            placeholder={t('filter.startDate')}
            value={filterState?.startedAt}
            onChange={(value) => handleFilter({ field: 'startedAt', value })}
          />
          <TextRegular>-</TextRegular>
          <FilterDatepicker placeholder={t('filter.endDate')} value={filterState?.endedAt} onChange={(value) => handleFilter({ field: 'endedAt', value })} />
        </Flex>
      </Box>
      <Box>
        <ButtonSolid className={styles['filter__button-export']} onClick={handleExport}>
          <DownloadIcon size="14px" /> <TextSemiBold className={styles['filter_button-export--text']}>{ReportHostTasksText.buttonExportText}</TextSemiBold>
        </ButtonSolid>
      </Box>
    </Box>
  );
};

export default Filter;
